/** @file The import dialog's buttons: Import (choosing), Retry the rest (failed upload), Close. */
import type { Translate } from '@pose2d/i18n/types';
import { names } from '@pose2d/format/names';
import { Button } from '../ui-kit/Button';
import type { ImportDraft, ImportSession, ImportStep } from './importTypes';

/** Import needs a checked layer and, for a new project, a valid ASCII name (also before Retry); Close is disabled while uploading. */
export function ImportFooter({ t, step, session }: { t: Translate; step: Exclude<ImportStep, { kind: 'closed' }>; session: ImportSession }) {
  const start = (): void => { void session.start(); };
  const draft = step.kind === 'choose' ? step.draft : null;
  const checked = draft?.choices.filter((c) => c.checked).length ?? 0;
  const badName = (d: { target: ImportDraft['target'] } | null): boolean => d?.target.kind === 'newProject' && !names.isValid('project', d.target.name);
  const unnamed = badName(draft);
  const retry = step.kind === 'failed' && step.draft !== null;
  return (
    <>
      {draft === null ? null : <Button primary label={t('psdImport.start', { n: checked })} disabled={checked === 0 || unnamed} onClick={start} />}
      {retry ? <Button primary label={t('psdImport.retry')} disabled={badName(step.draft)} onClick={start} /> : null}
      <Button label={t('psdImport.close')} disabled={step.kind === 'uploading'} onClick={session.close} />
    </>
  );
}
